import { useRestaurant } from "@/context/RestaurantContext";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { MapPin, ChevronRight } from "lucide-react";

export default function RestaurantSelector() {
  const { restaurants, loading, selectRestaurant } = useRestaurant();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="w-full max-w-lg space-y-4">
          {[1, 2, 3].map((i) => <Skeleton key={i} className="h-24 w-full" />)}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg" data-testid="restaurant-selector">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-slate-900 mb-2">
            ¿A qué restaurante quieres hacer el pedido?
          </h1>
          <p className="text-slate-500">Selecciona un centro para ver su catálogo</p>
        </div>

        <div className="space-y-3">
          {restaurants.length === 0 && (
            <Card className="border-dashed border-slate-300" data-testid="restaurant-selector-empty">
              <div className="p-5 text-center text-slate-500">
                No hay restaurantes disponibles para esta cuenta.
              </div>
            </Card>
          )}
          {restaurants.map((rest) => (
            <Card
              key={rest.restaurant_id}
              className="cursor-pointer hover:border-blue-400 hover:shadow-md transition-all"
              onClick={() => selectRestaurant(rest)}
              data-testid={`select-restaurant-${rest.restaurant_id}`}
            >
              <div className="p-5 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-slate-900 text-lg">{rest.name}</h2>
                    {rest.address && (
                      <p className="text-sm text-slate-500">{rest.address}</p>
                    )}
                    <div className="flex gap-2 mt-1">
                      {rest.branch && (
                        <span className="text-xs px-1.5 py-0.5 bg-indigo-50 text-indigo-700 rounded font-medium">
                          {rest.branch}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-slate-400" />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
